import React, { lazy } from 'react';
import authRoles from '../../../auth/authRoles';

const EventGroup = lazy(() => import('./eventGroups/wizard/EventGroup'));
const EventGroups = lazy(() =>
	import('@ameroservices-platform/attraction-backend/app/main/apps/wizards/eventGroups/list/EventGroups')
);
const EventGroupDetails = lazy(() =>
	import('@ameroservices-platform/attraction-backend/app/main/apps/wizards/eventGroups/details/EventGroupDetails')
);

const EntranceGroup = lazy(() =>
	import('@ameroservices-platform/attraction-backend/app/main/apps/wizards/entranceGroups/wizard/EntranceGroup')
);
const EntranceGroups = lazy(() =>
	import('@ameroservices-platform/attraction-backend/app/main/apps/wizards/entranceGroups/list/EntranceGroups')
);
const EntranceGroupDetails = lazy(() =>
	import(
		'@ameroservices-platform/attraction-backend/app/main/apps/wizards/entranceGroups/details/EntranceGroupDetails'
	)
);
const ProductGroupRuleBuilder = lazy(() =>
	import('@ameroservices-platform/attraction-backend/app/main/apps/wizards/ruleBuilder/ProductGroupRuleBuilder')
);

const ProductRuleBuilder = lazy(() =>
	import('@ameroservices-platform/attraction-backend/app/main/apps/wizards/ruleBuilder/ProductRuleBuilder')
);

const WizardsAppConfig = {
	settings: {
		layout: {}
	},
	routes: [
		// Entrance groups
		{
			path: '/apps/entrance-group/create',
			element: <EntranceGroup />
		},
		{
			path: '/apps/entrance-group/edit/:documentUid',
			element: <EntranceGroup />
		},
		{
			path: '/apps/entrance-group/edit/:documentUid/:tab',
			element: <EntranceGroup />
		},
		{
			path: '/apps/entrance-group/edit/:documentUid/:tab/:productGroupUid',
			element: <EntranceGroup />
		},
		{
			path: '/apps/entrance-groups',
			element: <EntranceGroups />
		},
		{
			path: '/apps/entrance-group/details/:documentUid',
			element: <EntranceGroupDetails />
		},
		// Event groups
		{
			path: '/apps/event-group/create',
			element: <EventGroup />
		},
		{
			path: '/apps/event-group/edit/:documentUid',
			element: <EventGroup />
		},
		{
			path: '/apps/event-group/edit/:documentUid/:tab',
			element: <EventGroup />
		},
		{
			path: '/apps/event-group/edit/:documentUid/:tab/:productGroupUid',
			element: <EventGroup />
		},
		{
			path: '/apps/event-groups',
			element: <EventGroups />
		},
		{
			path: '/apps/event-group/details/:documentUid',
			element: <EventGroupDetails />
		},
		// All
		{
			path: '/apps/entrance-group/advanced-rules/product-group/:productGroupUid',
			element: <ProductGroupRuleBuilder />
		},
		{
			path: '/apps/entrance-group/advanced-rules/product/:productUid',
			element: <ProductRuleBuilder />
		}
	]
};

export default WizardsAppConfig;
